// OrtoSoft — i18n — Français (langue officielle du site)

const fr = {
  // navigation
  'nav.home': 'OrtoSoft — accueil',
  'nav.contact': 'Contact',
  'nav.tel': 'Tél.',
  'nav.telShort': 'Tél.',
  'nav.email': 'Email',

  // hero — front de feuille
  'hero.kicker': 'Portefeuille — OrtoSoft',
  'hero.oAria': 'Le logo O d’OrtoSoft, construit géométriquement',
  'hero.lede':
    'Des logiciels conçus et construits droit. Trois produits, en ligne — inspectez les dessins, puis parlez-moi de votre projet.',
  'hero.ctaDrawings': 'Voir les dessins',
  'hero.ctaContact': 'Contact',
  'note.scale': 'Échelle',
  'note.author': 'Auteur',
  'note.sheets': 'Feuilles',
  'note.year': 'Année',

  // sections
  'section.series': 'Série',
  'section.drawings': 'Les dessins',
  'section.drafter': 'Le dessinateur',

  // dessins
  'sheet.tab': 'Dessin',
  'sheet.reading': 'distance de lecture',
  'dist.overview': 'Vue d’ensemble',
  'dist.action': 'En action',
  'dist.hood': 'Sous le capot',
  'sheet.visit': 'Visiter',
  'sheet.login': 'Connexion',
  'sheet.demo': 'Voir la démo',
  'sheet.get': 'Obtenir',
  'plate.fig': 'Capt.',

  // dessin 01 — céphalométrie
  'p01.title': 'Céphalométrie',
  'p01.sub':
    'Analyses céphalométriques et suivi patients — pour le cabinet dentaire.',
  'p01.across':
    'Un logiciel d’analyses céphalométriques et de suivi patients, pensé avec les cabinets — les 20 points céphalométriques sont tracés automatiquement par IA en moins d’une seconde, avec un suivi du traitement : photos, go / no-go pour chaque étape (aligneurs ou bagues).',
  'p01.capTracing': 'Traçé réel',
  'p01.capDemo': 'Démo — vidéo',
  'p01.f1k': 'Fonction',
  'p01.f1v': 'Analyses céphalométriques et suivi patients',
  'p01.f2k': 'Cible',
  'p01.f2v': 'Cabinets dentaires et orthodontistes',
  'p01.f3k': 'Produit',
  'p01.f3v': 'ortho.ortosoft.fr — en ligne',
  'p01.f4k': 'Démonstration',
  'p01.f4v': 'Vidéo de présentation (YouTube)',
  'p01.f5k': 'Traitement IA',
  'p01.f5v': '20 points céphalométriques tracés automatiquement en moins d’une seconde',
  'p01.f6k': 'Suivi patients',
  'p01.f6v': 'Le patient reçoit un lien web pour envoyer les photos définies selon le protocole du praticien — moins de rendez-vous, gain de temps',

  // dessin 02 — simple bookmarks
  'p02.title': 'Simple Bookmarks',
  'p02.sub': 'Gestionnaire de favoris — simple et écologique.',
  'p02.across': 'Retrouver ses favoris, d’une manière simple et écologique. Changez de navigateur sans le tracas de l’import/export de favoris — connectez-vous de n’importe où et retrouvez-les vite.',
  'p02.capLive': 'En ligne',
  'p02.f1k': 'Fonction',
  'p02.f1v': 'Gestionnaire de favoris de navigateur',
  'p02.f2k': 'Principe',
  'p02.f2v': 'Simple et écologique — l’essentiel, rien de plus',
  'p02.f3k': 'Produit',
  'p02.f3v': 'sb.ortosoft.fr — en ligne',

  'p03.title': 'Doctolib Pro - export agenda',
  'p03.sub': 'Extension Chrome — l’agenda du jour, exporté en un clic.',
  'p03.across': 'Le compteur du jour s’affiche sur pro.doctolib.fr ; un clic exporte l’agenda en JSON — téléchargement local ou POST vers le serveur du praticien.',
  'p03.capPopup': 'Sur la page — compteur du jour, bouton Export',
  'p03.capOptions': 'Options — adresse du serveur (POST) ou téléchargement local',
  'p03.f1k': 'Fonction',
  'p03.f1v': 'Extension Chrome pour pro.doctolib.fr',
  'p03.f2k': 'Export',
  'p03.f2v': 'JSON — téléchargement local ou POST vers son propre serveur',
  'p03.f3k': 'Produit',
  'p03.f3v': 'Chrome Web Store',

  // le dessinateur
  'about.line':
    'Bogdan Scanteie — designer & développeur, OrtoSoft. Ouvert aux collaborations et aux projets freelance.',
  'about.tag': 'Le droit angle : l’idée droite, l’outil juste.',
  'about.write': 'Écrire',
  'about.call': 'Appeler',

  // titre-bloc (footer)
  'footer.company': 'Société',
  'footer.contact': 'Contact',
  'footer.legal': 'Légales',
  'footer.ref': 'Réf.',
  'footer.cgv': 'CGV',
  'footer.ml': 'Mentions légales',

  // page légale
  'ml.tab': 'Fiche légale',
  'ml.title': 'Mentions légales',
  'ml.societe': 'Société',
  'ml.cookies': 'Cookies',
  'ml.cgv': 'Conditions générales de vente',
  'ml.host': 'Hébergeur',
};

export default fr;
